import { PERIPHERAL_TYPE_PRINTER } from "@constants/index";
import { logger } from "@helpers/logger";

/**
 * Shape of a single row returned by the resource-IP feed at
 * `/settings/general/ip_resources`. Some legacy payloads expose `Id`
 * (uppercase) instead of `id`, hence both are optional.
 */
export interface IpResourceEntry {
    id?: string;
    Id?: string;
    ip: string;
    type: string;
    shopId: string;
}

export function checkIpIfExist(
    allData: IpResourceEntry[],
    ip: string,
    idPer: string,
    shopId: string,
    ty?: string
): boolean {
    try {
        const fetchedList = allData
            .filter((x: IpResourceEntry) => {
                if (
                    ty === PERIPHERAL_TYPE_PRINTER &&
                    x.type === PERIPHERAL_TYPE_PRINTER
                ) {
                    return false;
                }
                if (x.shopId !== shopId) return false;
                const itemId = x.id ?? x.Id;
                if (idPer.length > 0 && itemId === idPer) return false;
                return Boolean(x.ip);
            })
            .map((x: IpResourceEntry) => x.ip);

        return fetchedList.indexOf(ip) !== -1;
    } catch (error) {
        logger.error("Error in checkIpIfExist:", error);
        return true;
    }
}
